<template>
  <div class="consult-crud">
    <avue-crud
      ref="crud"
      :data="data"
      :option="option"
      :page.sync="page"
      v-model="form"
      @on-load="changPage"
      @search-change="search"
      @row-save="create"
      @row-update="update"
      @row-del="remove"
    >
      <!-- 表格里的封面缩略图：点击可放大预览 -->
      <template slot="cover" slot-scope="scope">
        <el-image
          v-if="scope.row.cover"
          :src="scope.row.cover"
          :preview-src-list="[scope.row.cover]"
          fit="cover"
          style="width: 80px; height: 50px"
        />
        <span v-else>-</span>
      </template>

      <!-- 发布时间直接展示存库字符串（本身就是 YYYY-MM-DD HH:mm:ss） -->
      <template slot="publishTime" slot-scope="scope">
        {{ scope.row.publishTime || "-" }}
      </template>
    </avue-crud>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
        pageSizes: [10, 20, 50],
      },
      query: {
        page: 1,
        limit: 10,
        where: {},
      },
      data: [],
      form: {},
      option: {
        border: true,
        index: true,
        indexLabel: "序号",
        searchMenuSpan: 4,
        dialogWidth: 900,
        menuWidth: 220,
        viewBtn: true,
        align: "center",
        dialogClickModal: false,
        translate: false,
        column: [
          {
            label: "标题",
            prop: "title",
            span: 12,
            width: 240,
            search: true,
            rules: [
              { required: true, message: "请输入标题", trigger: "blur" },
            ],
          },
          {
            label: "咨询分类",
            prop: "category",
            type: "select",
            span: 12,
            search: true,
            props: {
              label: "label",
              value: "label",
            },
            // 选项来自字典 consult.category（字典管理页可增删改）
            dicUrl: "dictionaries/type/consult.category",
            rules: [
              { required: true, message: "请选择咨询分类", trigger: "change" },
            ],
          },
          {
            label: "封面图",
            prop: "cover",
            type: "upload",
            dataType: "string",
            listType: "picture-img",
            action: "upload",
            span: 12,
            slot: true,
            width: 120,
          },
          {
            label: "发布时间",
            prop: "publishTime",
            type: "datetime",
            span: 12,
            slot: true,
            width: 170,
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            // 新增时默认当前时间，可手动改
            mock: {
              type: "datetime",
              format: "yyyy-MM-dd HH:mm:ss",
              now: true,
            },
            rules: [
              { required: true, message: "请选择发布时间", trigger: "change" },
            ],
          },
          {
            label: "摘要",
            prop: "summary",
            type: "textarea",
            span: 24,
            minRows: 3,
            hide: true,
            showColumn: false,
          },
          {
            label: "正文",
            prop: "content",
            type: "input-html",
            span: 24,
            hide: true,
            showColumn: false,
            rules: [
              { required: true, message: "请输入正文", trigger: "blur" },
            ],
          },
        ],
      },
    };
  },
  methods: {
    async changPage({ pageSize, currentPage }) {
      this.query.page = currentPage;
      this.query.limit = pageSize;
      this.fetch();
    },
    // 搜索：标题模糊（转义后正则）、分类走字典值精确匹配
    search(where, done) {
      done();
      if (where.title) {
        where.title = { $regex: this.escapeRegex(where.title), $options: "i" };
      }
      this.query.where = where;
      this.fetch();
    },
    escapeRegex(s) {
      return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    },
    async fetch() {
      const res = await this.$http.get("consults", {
        params: {
          // nestjs-mongoose-crud 约定：query 为 JSON 字符串，服务端 JSON.parse 后取 page/limit/where
          query: JSON.stringify(this.query),
        },
      });
      this.page.total = res.data.total;
      this.data = res.data.data;
    },
    // 发布时间统一落成 "YYYY-MM-DD HH:mm:ss" 字符串：
    // 未改动时间选择器时 mock 给的是 Date 对象，这里兜底转字符串，保证与手动选择的格式一致
    normalizePublishTime(row) {
      const v = row.publishTime;
      const t = v instanceof Date ? v : new Date(v);
      if (!v || isNaN(t.getTime())) {
        row.publishTime = "";
        return row;
      }
      const pad = (n) => String(n).padStart(2, "0");
      row.publishTime = `${t.getFullYear()}-${pad(t.getMonth() + 1)}-${pad(
        t.getDate()
      )} ${pad(t.getHours())}:${pad(t.getMinutes())}:${pad(t.getSeconds())}`;
      return row;
    },
    async create(row, done) {
      await this.$http.post("consults", this.normalizePublishTime(row));
      this.$message.success("创建成功");
      this.fetch();
      done();
    },
    async update(row, index, done) {
      await this.$http.put(
        `consults/${row._id}`,
        this.normalizePublishTime(row)
      );
      this.$message.success("更新成功");
      this.fetch();
      done();
    },
    async remove(row) {
      try {
        await this.$confirm("是否确认删除该条咨询？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
      } catch (e) {
        return;
      }
      await this.$http.delete(`consults/${row._id}`);
      this.$message.success("删除成功");
      this.fetch();
    },
  },
  created() {
    this.fetch();
  },
};
</script>
